import type Store from "@ember-data/store";
import { tracked } from "@glimmer/tracking";
import type { DmpAdapter } from "parog-web/cnam-adapters/dmp-adapter";
import type { InsiAdapter } from "parog-web/cnam-adapters/insi-adapter";
import InsRetrieveAccessFormConfirmIdentityComponent from "parog-web/components/ins-retrieve-access-form/confirm-identity";
import type Patient from "parog-web/models/patient";
import type { OperationType } from "./abstract/cnam-context";
import { State } from "./abstract/cnam-context";
import type { AuthenticationContext } from "./authentication-context";
import InsRetrievalContext from "./ins-retrieval-context";

export default class InsWithConfirmationRetrievalContext extends InsRetrievalContext {
  @tracked isIdentitySaved = false;

  constructor(
    cnamAdapterName: string,
    patient: Patient,
    authenticationContext: AuthenticationContext,
    insiAdapter: InsiAdapter,
    dmpAdapter: DmpAdapter,
    store: Store,
    requestManager,
    operationType: OperationType,
    onSuccess?: () => Promise<void>
  ) {
    super(
      cnamAdapterName,
      patient,
      authenticationContext,
      insiAdapter,
      dmpAdapter,
      store,
      requestManager,
      operationType,
      onSuccess
    );

    this.states = [
      ...this.states,
      new State(
        "save-identity",
        (): Promise<boolean> => {
          return Promise.resolve(
            Boolean(this.identityResult) && !this.isIdentitySaved
          );
        },
        async (): Promise<void> => {
          await this._savePatientIdentity(this.identityResult, this.patient);
          await this._saveInsRetrieve(patient, this.identityResult, true);
          await this.onSuccess?.();

          this.isIdentitySaved = true;
        },
        InsRetrieveAccessFormConfirmIdentityComponent
      )
    ];
  }

  override reset() {
    super.reset();
    this.successKey = undefined;
  }
}
